// src/components/calendar/ThreeMonthsView.tsx
import { subMonths, addMonths } from "date-fns"
import { MonthCalendar } from "./MonthCalendar"

interface ThreeMonthsViewProps {
  currentDate: Date
  onDayClick?: (date: Date) => void
  filterType?: "all" | "task" | "holiday"
}

export function ThreeMonthsView({ currentDate, onDayClick, filterType }: ThreeMonthsViewProps) {
  const prevMonth = subMonths(currentDate, 1)
  const nextMonth = addMonths(currentDate, 1)

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
      <MonthCalendar date={prevMonth} onDayClick={onDayClick} filterType={filterType} />
      <MonthCalendar date={currentDate} onDayClick={onDayClick} filterType={filterType} />
      <MonthCalendar date={nextMonth} onDayClick={onDayClick} filterType={filterType} />
    </div>
  )
}